'use strict';

export default angular
  .module('maestro.directives.semantic.popup', [])

  .service('suiPopup', function() {
    const me = this;

    me.hideAll = function() {
      $('*[popup]').each((i, el) => $(el).popup('hide'));
    };
  })

  .directive('suiPopup', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attributes) {
        scope.$watch(attributes.popup, function(config = {}) {

          // Set HTML with icon instead of content
          if (attributes.icon && attributes.icon !== '') {
            config.html = `<icon i="${attributes.icon}" class="icon"></icon> ${attributes.content}`;
            //config.on = 'click'; // Debug popup
          }

          element.popup(config);
        });
        attributes.$observe('content', function(newStr) {
          if (element.popup('is visible') === true) {
            let popup = element.popup('get popup');
            if (!element.is(popup)) {
              popup.text(newStr);
            }
          }
        });
        element.on('$destroy', function() {
          element.popup('destroy');
        });
      }
    };
  })

  .name;
